// extracted by mini-css-extract-plugin
module.exports = {"number":"CounterVy_number__2IEYP"};